import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import Link from 'next/link';

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderBottom: '1px dashed #e5e5e5',
        padding: 6,
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#c1c4cf',
            borderRadius: 4,
        },
    },
    number: {
        fontSize: 14,
        color: '#2b2bb3',
    },
    title: {
        fontSize: 12,
        color: '#4e4e4e',
    },
    date: {
        fontSize: 12,
        color: '#545454',
        minWidth: 'fit-content',
    },
}));

export const DocItem = (props) => {
    const classes = useStyles();

    return (
        <Link href={`jobs/${props.id}`} passHref>
            <a>
                <Box className={classes.root}>
                    <Box className={classes.title}>{props.title}</Box>
                    <Box className={classes.date}>{props.open_date.split('T')[0]}</Box>
                </Box>
            </a>
        </Link>
    );
};

DocItem.propTypes = {
    name: PropTypes.string,
    onAdd: PropTypes.func,
};

DocItem.defaultProps = {
    name: 'hello',
};

export default DocItem;
